// TODO pujezdsky URL na resourcy pres devel proxy
export function getServerBasename() {
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  return 'http://muj.sokol.local:8082';
}
